<template>
  <div class="recycle-book-list">
    <div class="item-info">
      <span class="orderid">订单号：{{ item.id }}</span>
      <span class="time">{{ createTime }}</span>
    </div>
    <!-- <z-divider /> -->
    <div class="item-pic">
      <div class="book-info">
        <span class="left">共{{ item.productNum }}本</span>
        <!-- ，预估¥{{ item.price }} -->
        <span class="right">{{ itemState }}</span>
      </div>
      <div class="hidescrollbar">
        <div class="horizontal">
          <ul class="list-wrapper">
            <li
              v-for="(img, index) in item.productPics"
              :key="index"
              class="scroll-pic"
              :style="{ backgroundImage: 'url(' + $setPicSize(img) + ')' }"
            ></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'RecycleBookList',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    createTime() {
      return this.item.time ? new Date(Number(this.item.time)).format('YYYY-MM-DD') : '' //  2018-02-21
    },
    itemState() {
      if (this.item.status.length > 4) {
        return this.item.status.slice(0, 4)
      }
      return this.item.status
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 200)
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
